



import { Component, Vue } from "vue-property-decorator";
import {
    logout,
} from '@/req/user'
@Component
export default class Logout extends Vue {}
